import {
  SET_CO_APPLICANT,
  SET_SUB_STEP,
  SET_OPEN_VERIFICATION,
  SET_APPLICATION_COMPLETE,
  SET_COMPANY_VERIFICATION_METHOD,
  SET_PERSON_DATA,
  SET_PARTNER_DETAILS,
  SET_FUND_DETAILS,
  SET_SINGPASS_INFO,
  SET_LOAN_STEP,
  SET_ENTITY_DATA,
  SET_LOAN_SUB_STEP,
  SET_LOAN_APPLICATION,
} from '../types'

export const setSubStep = (step: number) => ({
  type: SET_SUB_STEP,
  step,
})

export const setCoApplicant = (co_applicant: any) => ({
  type: SET_CO_APPLICANT,
  co_applicant,
})

export const setPartnerDetails = (payload: any) => ({
  type: SET_PARTNER_DETAILS,
  payload,
})

export const setOpenVerification = (open: boolean) => ({
  type: SET_OPEN_VERIFICATION,
  open,
})

export const setApplicationComplete = (complete: boolean) => ({
  type: SET_APPLICATION_COMPLETE,
  complete,
})

export const setCompanyVerificationMethod = (method: number) => ({
  type: SET_COMPANY_VERIFICATION_METHOD,
  method,
})

export const setPersonData = (payload: any) => ({
  type: SET_PERSON_DATA,
  payload,
})

export const setFundDetails = (payload: any) => ({
  type: SET_FUND_DETAILS,
  payload,
})

export const setSingPassInfo = (payload: any) => ({
  type: SET_SINGPASS_INFO,
  payload,
})

export const setLoanStep = (step: number) => ({
  type: SET_LOAN_STEP,
  step,
})
export const setLoanSubStep = (step: number) => ({
  type: SET_LOAN_SUB_STEP,
  step,
})

export const setEntityData = (payload: any) => ({
  type: SET_ENTITY_DATA,
  payload,
})

export const setLoanApplication = (payload: any) => ({
  type: SET_LOAN_APPLICATION,
  payload,
})
